import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '../contexts/AuthContext';
import { ToastProvider } from '@contexts';
import { ProtectedRoute } from '@components/auth';
import { AppLayout } from './layout';
import { Login } from '@features/login';
import { Dashboard } from '@features/dashboard';
import { FindEstate } from '@features/estateFind';
import { ReviewEdit } from '@features/estateEdit';
import { Export } from '@features/export';
import { Settings } from '@features/settings';
import { BlocPlusBrowse } from '@features/blocPlusBrowse';
import { AskLotti } from '@features/askLotti';
import { MergePlans } from '@features/merge';
import { ProposedEstates } from '@features/proposedEstates';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="find" element={<FindEstate />} />
              <Route path="blocplus" element={<BlocPlusBrowse />} />
              <Route path="proposed-estates" element={<ProposedEstates />} />
              <Route path="edit/:id" element={<ReviewEdit />} />
              <Route path="export/:id" element={<Export />} />
              <Route path="merge" element={<MergePlans />} />
              <Route path="lotti" element={<AskLotti />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
